import { render, staticRenderFns } from "./MedicalPendingApplications.vue?vue&type=template&id=337659af"
import script from "./MedicalPendingApplications.vue?vue&type=script&lang=js"
export * from "./MedicalPendingApplications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports